/** Класс CSS для подписи LABEL — паритет XML align (Swing). */
export function resolveSimpleLabelAlignClass(options: {
  align: string
  cols: number
  colspan: number
  hasRightActions: boolean
  hugStandalone?: boolean
}): string {
  if (options.hugStandalone) return 'element-simple-label--align-left'
  const align = String(options.align ?? 'left').trim().toLowerCase() || 'left'
  return `element-simple-label--align-${align}`
}
